import createLucideIcon from '../createLucideIcon';

const Search = createLucideIcon('Search', [
  ['circle', { cx: '11', cy: '11', r: '8', key: '4ej97u' }],
  ['line', { x1: '21', y1: '21', x2: '16.65', y2: '16.65', key: '1p50m8' }],
]);

export default Search;
